import { FC, ReactNode } from "react";
import { Table, TablePaginationConfig, Typography } from "antd";
import { StyledTable } from "./styled";

interface IProps {
  pagination: false | TablePaginationConfig | undefined;
  data: {
    key: React.Key;
    number: number | ReactNode;
    contrantor: string;
    time: number;
    unaccepted: number;
    status: string | ReactNode;
  }[];
}

export const ContractorsRatingTable: FC<IProps> = ({ data, pagination }) => {
  const { Column } = Table;

  return (
    <StyledTable
      scroll={{ y: "30vh" }}
      pagination={pagination}
      dataSource={data}
    >
      <Column
        width={"10%"}
        align="left"
        title="№"
        dataIndex="number"
        key="number"
        render={(number: string) => (
          <Typography.Title
            level={5}
            style={{
              margin: 0,
              color: "#4A5368",
              fontSize: "14px",
              fontWeight: "400",
            }}
          >
            {number}
          </Typography.Title>
        )}
      />

      <Column
        width={"30%"}
        align="left"
        title="Подрядчик"
        dataIndex="contrantor"
        key="contrantor"
        render={(contrantor: string[]) => (
          <Typography.Title
            level={5}
            style={{
              margin: 0,
              color: "#4A5368",
              fontSize: "14px",
              fontWeight: "400",
            }}
          >
            {contrantor}
          </Typography.Title>
        )}
      />

      <Column
        width={"25%"}
        align="right"
        title="Время принятия РД"
        dataIndex="time"
        key="time"
        render={(time: string) => (
          <Typography.Title
            level={5}
            style={{
              margin: 0,
              color: "#4A5368",
              fontSize: "12px",
              fontWeight: "400",
            }}
          >
            {time} ч
          </Typography.Title>
        )}
      />

      <Column
        width={"25%"}
        align="right"
        title="Непринятых РД"
        dataIndex="unaccepted"
        key="unaccepted"
        render={(unaccepted: string) => (
          <Typography.Title
            level={5}
            style={{
              margin: 0,
              color: "#4A5368",
              fontSize: "12px",
              fontWeight: "400",
            }}
          >
            {unaccepted}
          </Typography.Title>
        )}
      />

      <Column align="center" title="Статус" dataIndex="status" key="status" />
    </StyledTable>
  );
};
